// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + ({"701":"catalog","894":"services"}[chunkId] || chunkId) + "." + {"430":"5006c910","513":"1c4b8ee9","701":"b6e4e6f9","894":"c0b109f1"}[chunkId] + ".css";
};